import React, { useState } from 'react';

// Utils
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import adminTypeOptions from '../../../constants/adminTypesOptions';
import forgotPasswordSchema from '../../../validations/forgotPasswordSchema';

// Services
import useAuthService from '../../../services/authService';

// Components
import AuthTemplate from '../../layout/AuthTemplate/AuthTemplate';
import InputField from '../../atoms/InputField/InputField';
import Button from '../../atoms/Button/Button';
import FlashMessage from '../../molecules/FlashMessage/FlashMessage';
import RadioGroup from '../../molecules/RadioGroup/RadioGroup';

function ForgotPasswordForm() {
  const { t } = useTranslation();

  const [adminType, setAdminType] = useState(adminTypeOptions[0]?.name);

  const { postInitPasswordReset } = useAuthService();

  const {
    mutate: postResetMutate, isLoading, isSuccess, isError,
  } = useMutation(postInitPasswordReset);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: (values) => {
      postResetMutate({ adminType, email: values.email });
    },
    validationSchema: forgotPasswordSchema,
  });

  return (
    <AuthTemplate title={t('login.login')} showBackButton>
      <h2 className="fs-20 fw-500 m-b-20">{t('login.forgot.title')}</h2>

      {isError ? (
        <FlashMessage
          message={t('code_errors.generic')}
          color="error"
          className="m-b-20"
        />
      ) : null}

      {isSuccess ? (
        <FlashMessage
          message={t('login.forgot.success', { email: formik.values.email })}
          color="success"
          className="m-b-20"
        />
      ) : (
        <FlashMessage message={t('login.forgot.text')} />
      )}

      <form onSubmit={formik.handleSubmit} className="m-t-20">
        <div className="m-b-20">
          <p className="m-b-10 fs-13 fw-500">
            {`${t('login.types.admin')} :`}
          </p>
          <RadioGroup
            groupName="adminTypes"
            entries={adminTypeOptions.map((option) => ({ name: option.name, label: t(option.label) }))}
            selected={adminType}
            setSelected={(value) => setAdminType(value)}
            required
          />
        </div>

        <InputField
          id="forgot_email"
          name="email"
          value={formik.values.email}
          label={t('login.email')}
          formik={{
            handleChange: formik.handleChange,
            handleBlur: formik.handleBlur,
          }}
          error={formik.errors?.email && formik.touched?.email ? formik.errors.email : null}
          isRequired
        />

        <div className="m-t-20">
          <Button submitType isLoading={isLoading}>
            {t('login.forgot.submit')}
          </Button>
        </div>
      </form>

    </AuthTemplate>
  );
}

ForgotPasswordForm.propTypes = {};

export default ForgotPasswordForm;
